import { Instance } from 'mobx-state-tree';
import { OrderDeliveryProgressDtoModelBase } from './OrderDeliveryProgressDtoModel.base';

/* The TypeScript type of an instance of OrderDeliveryProgressDtoModel */
export interface OrderDeliveryProgressDtoModelType extends Instance<typeof OrderDeliveryProgressDtoModel.Type> {}

/* A graphql query fragment builders for OrderDeliveryProgressDtoModel */
export { selectFromOrderDeliveryProgressDto, orderDeliveryProgressDtoModelPrimitives, OrderDeliveryProgressDtoModelSelector } from './OrderDeliveryProgressDtoModel.base';

/**
 * OrderDeliveryProgressDtoModel
 */
export const OrderDeliveryProgressDtoModel = OrderDeliveryProgressDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
